module.exports = __webpack_public_path__ + "assets/63e0b7a14d658cce7b43e11aa7dc248a.png";